import React from "react";
import { View, StyleSheet, Platform, Pressable } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";

interface CourseInfoCardProps {
  icon: React.ReactNode;
  number: number;
  title: string;
  iconColor: string;
  borderColor?: string;
  activeBackgroundColor?: string;
  activeBorderColor?: string;
  isActive?: boolean;
  onPress?: () => void;
}

const CourseInfoCard: React.FC<CourseInfoCardProps> = ({
  icon,
  number,
  title,
  iconColor,
  borderColor,
  activeBackgroundColor,
  activeBorderColor,
  isActive = false,
  onPress,
}) => {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole={onPress ? "button" : undefined}
      accessibilityLabel={onPress ? `${title} filter` : undefined}
      accessibilityState={onPress ? { selected: isActive } : undefined}
      style={[
        styles.card,
        borderColor && { borderColor },
        isActive && styles.cardActive,
        isActive && activeBackgroundColor && { backgroundColor: activeBackgroundColor },
        isActive && activeBorderColor && { borderColor: activeBorderColor },
      ]}>
      <View style={styles.iconContainer}>
        {React.cloneElement(icon as React.ReactElement, {
          size: 22,
          color: iconColor,
          weight: "regular",
        })}
      </View>
      <View style={styles.content}>
        <CustomText
          useTranslationText={false}
          text={number.toString()}
          size="xs"
          weight="bold"
          style={styles.number}
          textType="display"
        />
        <CustomSpacing type="vertical" size="xs" />
        <CustomText useTranslationText={false} text={title} size="s" style={styles.title} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  card: {
    flexDirection: "row",
    alignItems: "center",
    padding: 18,
    backgroundColor: Platform.select({
      web: "rgba(255, 255, 255, 0.6)",
      default: "rgba(255, 255, 255, 0.95)",
    }),
    borderRadius: 42,
    borderWidth: 1,
    borderColor: "#EAECF0",
    ...(Platform.OS === "web"
      ? ({
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
        } as any)
      : {}),
    flex: 1,
  },
  cardActive: {
    borderColor: "#3E68FE",
    backgroundColor: "#FFFFFF",
  },
  iconContainer: {
    width: 22,
    height: 22,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  content: {
    flex: 1,
  },
  number: {
    color: "#101828",
  },
  title: {
    color: "#475467",
  },
});

export default CourseInfoCard;
